<fa-icon [icon]="['fal', iconType]" [size]="size" [spin]="spin"></fa-icon>
